export const secretKey = "needabettersecretfromtheenvironment"